var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutboundHandled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Outbound_Handled"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outbound_Handled",
    clipPath: "url(#clip-Outbound_Handled)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbound_call_Icon",
    "data-name": "inbound call Icon",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Call_copy",
    "data-name": "Call copy",
    d: "M903.445,1058.522s.762,12.154,11.223,16.311a5.684,5.684,0,0,0,6.689-1.986s.535-1.187-1.03-2.431l-2.817-2.177a1.246,1.246,0,0,0-1.418.035l-1.659,1.3s-.461.584-1.547-.074a17.534,17.534,0,0,1-4.875-7.351,1.061,1.061,0,0,1,.591-1.1l1.346-.986s.811-.419.462-1.827l-.715-3.674a2.06,2.06,0,0,0-3.039-.99S903.91,1054.521,903.445,1058.522Z",
    transform: "translate(-903.445 -1053.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M7.812,6.588,2.96,1.736H6.944V0H0V6.944H1.736V2.96L6.673,7.867Z",
    transform: "translate(17.992 5.96) rotate(99)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundHandled);
export default __webpack_public_path__ + "static/media/Outbound_Handled.7dfc4bcc412f2ab820fa6a8871826535.svg";
export { ForwardRef as ReactComponent };